import * as React from "react";
import { IWithHistoryProp, withHistory } from "../../shared/hoc/with-history";
import "./no-match-404.scss";

const REDIRECT_SECONDS = 8;

export interface INoMatch404State {
  remaining: number;
  cancelled: boolean;
  path: string;
}

export interface INoMatch404Props {}

class NoMatch404 extends React.PureComponent<INoMatch404Props & IWithHistoryProp, INoMatch404State> {
  state: INoMatch404State = {
    remaining: REDIRECT_SECONDS,
    cancelled: false,
    path: typeof window !== "undefined" ? window.location.pathname : "/"
  };

  private intervalId: ReturnType<typeof setInterval> | null = null;

  componentDidMount() {
    this.intervalId = setInterval(() => {
      if (this.state.cancelled) return;
      const next = this.state.remaining - 1;
      if (next <= 0) {
        if (this.intervalId) {
          clearInterval(this.intervalId);
          this.intervalId = null;
        }
        this.props.navigator.gotoRoot();
        return;
      }
      this.setState({ remaining: next });
    }, 1000);
  }

  componentWillUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  private handleStay = () => {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    this.setState({ cancelled: true });
  };

  render() {
    const { remaining, cancelled, path } = this.state;

    return (
      <div className="nm404">
        <div className="nm404__inner">
          <div className="nm404__code" data-text="404">
            404
          </div>
          <div className="nm404__title">Page not found</div>
          <div className="nm404__body">
            We couldn't find <code>{path}</code>.
            <br />
            It may have moved, been archived, or never existed in the first place.
          </div>
          <div className="nm404__actions">
            <button
              type="button"
              className="nm404__btn nm404__btn--primary"
              onClick={() => this.props.navigator.gotoRoot()}
            >
              Back to home
            </button>
            {!cancelled && (
              <button type="button" className="nm404__btn nm404__btn--ghost" onClick={this.handleStay}>
                Stay on this page
              </button>
            )}
          </div>
          {!cancelled && (
            <div className="nm404__countdown">
              Redirecting in <span>{remaining}s</span>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const noMatch404 = withHistory<INoMatch404Props>(NoMatch404);
export { noMatch404 as NoMatch404 };
